import { React, useState, Dropdown, PageStyle, UserSwitchActions, CONSTANT, useRouter, clearSWRCache, useEffect, useSWR, useTranslation } from '@/imports-files/components/switch-user';
import  AgencyUser  from 'public/new-icons/agency-user.svg';
export function UserSwitch(props)
{
  const {t, i18n}= useTranslation();
  const [showDropdown, setShowDropdown] = useState(false);
  const router = useRouter();
  const [isLoading, setLoading] = useState(true);
  const userSwitchActions = new UserSwitchActions(router, props.session, props.setApiError);
  const [switchUserData, setSwitchUserData] = useState();
  const [name, setName] = useState();
//  const { data, error } = useSWR('user-switch', () => { return (userSwitchActions.getSwitchData()) })
  useEffect(() => {
 /*    if (props.data) { */
      if (router.asPath.includes('/clients')) {
        setSwitchUserData(props.data.agencies);
        setName('agency');
      }
      else {
        setSwitchUserData(props.data.clients);
         setName('client')
      }
      setLoading(false);
  /*   } */
  }, [])

  if (isLoading) {
    return '';
  }


  return (
    <Dropdown
      onMouseLeave={() => setShowDropdown(false)}
      onClick={() => setShowDropdown(true)}
    >
      <Dropdown.Toggle
        className="main-style"
        id="dropdown-basic"
      >
        <div className={`ml15 ${PageStyle.ClientCompany__FloatButtonAdd}`}>
          <div className={`${PageStyle.ClientCompany__FloatButtonAdd__AgencyUserIcon} AgencyUserIcon`}>
            <AgencyUser/>
          </div>
        </div>
      </Dropdown.Toggle>

      <Dropdown.Menu show={showDropdown}>

        {switchUserData.map((user, index) => {
          return (
            <Dropdown.Item className={`UserSwitchDropdown`} onClick={(event) => { userSwitchActions.switchUser(user.id) }} key={`switch_${index}`}>
              {t('agency:dashboard:switch_to_client_view', {name})}
            </Dropdown.Item>
          )
        })}

      </Dropdown.Menu>
    </Dropdown>
  );

}
